module.exports = __webpack_public_path__ + "img/main_home_phone_it.801047c.png";